// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
    "dirty": false,
    "raw": "19aed7f",
    "hash": "19aed7f",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "19aed7f",
    "semverString": null,
    "version": "1.4.0"
};
